import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import {
  handelConvertDataTagById,
  handleDataBusinessAge,
  handleSelectCheckBox,
} from '../filterSetting/helper'
import { getFilteredCompaniesBusinessAge } from './thunk'

const initialState = {
  dataBusinessAge: [],
  listSelectedBusinessAge: [],
  loading: {
    businessAge: false,
  },
}

const slice = createSlice({
  name: 'common/filterCompany/businessAge',
  initialState,
  reducers: {
    resetStoreBusinessAge: () => initialState,
    changeListSelectedListBusinessAge: (state, action) => {
      state.listSelectedBusinessAge = handleSelectCheckBox(
        state.listSelectedBusinessAge,
        action.payload,
      )
    },
    covertDataAgeById: (state, action) => {
      state.listSelectedBusinessAge = handelConvertDataTagById(
        action.payload,
        state.dataBusinessAge,
      )
    },
    resetBusinessAge: (state) => {
      state.listSelectedBusinessAge = []
    },
  },
  extraReducers: (builder) => {
    //get Filtered Companies Business Age
    builder.addCase(getFilteredCompaniesBusinessAge.pending, (state) => {
      state.loading.businessAge = true
    })
    builder.addCase(
      getFilteredCompaniesBusinessAge.fulfilled,
      (state, action) => {
        state.dataBusinessAge = handleDataBusinessAge(action.payload)
        state.loading.businessAge = false
      },
    )
    builder.addCase(
      getFilteredCompaniesBusinessAge.rejected,
      (state, action) => {
        state.loading.businessAge = action.payload.loading
      },
    )
  },
})

export const loadingAge = (state) => state[slice.name].loading.businessAge

export const selectDataBusinessAge = (state) =>
  state[slice.name].dataBusinessAge

export const selectListSelectedBusinessAge = (state) =>
  state[slice.name].listSelectedBusinessAge

export const {
  resetStoreBusinessAge,
  changeListSelectedListBusinessAge,
  resetBusinessAge,
  covertDataAgeById,
} = slice.actions

register(slice.name, slice.reducer)
